















































































import {Mutation} from 'vuex-module-decorators';
import {Component, Emit, Vue, Watch} from 'vue-property-decorator';
import contentsModule from '@/model/store/modules/contents-module';
import userModule from '@/model/store/modules/user-module';
import appModule from '@/model/store/modules/app-module';
import headerModule from '@/model/store/modules/header-module';
import detailModule from '@/model/store/modules/detail-module';
import headlineModule from '@/model/store/modules/headline-module';
import holidayModule from '@/model/store/modules/holiday-module';
import viewerService from '@/model/services/viewer-service';
import userService from '@/model/services/user-service';
import contentsService from '@/model/services/contents-service';
import CategoryExpansionPanel from '@/components/organisms/CategoryExpansionPanel.vue';
import SearchTab from '@/components/organisms/SearchTab.vue';
import Calender from '@/components/organisms/Calender.vue';
import {UserDataOnSessionStorageDataInterface, UserDataOnSessionStorageInterface} from '@/model/interfaces/user-interface';
import {GCIHeaderRes, GCIHeaderInfoRes, GCIHeaderListsInfoRes} from '@/model/dto/res/header/get-header-info-res';
import {GlobalConstants} from '@/common/constants';
import _ from 'lodash';

@Component({
  components: {
    'category-expansion-panel': CategoryExpansionPanel,
    'search-tab': SearchTab,
    'calender': Calender
  }
})
export default class RootViewer extends Vue {
  /** Data **/
  private omittedNum = 50;

  /** Computed **/
  get isLogin() {
    return userModule.userName !== '' && appModule.token !== '';
  }

  get isMobile() {
    return this.innerWidth <= 767;
  }

  get windowWidth() {
    return this.isMobile ? this.innerWidth - 16 : (window.innerWidth) - 32;
  }

  get windowHeight() {
    return window.innerHeight / 2.2;
  }

  get innerWidth() {
    return contentsModule.innerWidth;
  }

  get aspectRatio() {
    return contentsModule.innerWidth > 800 ? 3 : 1;
  }

  get text() {
    return {
      confirmation: GlobalConstants.TEXT.SAVECONFIRMATION,
      issave: GlobalConstants.TEXT.ISSAVE,
      cancel: GlobalConstants.TEXT.CANCEL
    };
  }

  private async onEdit() {
    const params: any = {};
    await appModule.updateIsHeaderImageDialog({
      type: 'save',
      state: true,
      title: `${this.text.issave}`,
      message: `${this.text.confirmation}`,
      data: params
    });
  }

  private onOpenHeaderImageDialog(header: GCIHeaderRes) {
    appModule.startLoading();
    headerModule.updateHeaderTargetId(header.id);
    headerModule.pushHeader({
      id: header.id,
      title: '',
      text: '',
      path: '',
      status: 0,
      deleted: false
    });
    const func = _.debounce(() => {
      headerModule.updateIsHeaderDialog(!headerModule.isHeaderDialog);
      appModule.stopLoading();
    }, 1000);
    func();
  }

  private onNewOpenHeaderImageDialog() {
    appModule.startLoading();
    const last = _.last(_.sortBy(this.headerListsInfo, 'id'));
    if (!last) { return false; }
    // const id = last.id;
    headerModule.pushHeader({
      id: last.id + 1,
      title: '',
      text: '',
      path: '',
      status: 0,
      deleted: false
    });
    headerModule.updateHeaderTargetId(last.id + 1);
    const func = _.debounce(() => {
      headerModule.updateIsHeaderDialog(!headerModule.isHeaderDialog);
      appModule.stopLoading();
    }, 1000);
    func();
  }

  get menuInfo() {
    return appModule.menuInfo;
  }

  get headerInfo() {
    return headerModule.headerInfo;
  }

  get headerListsInfo() {
    return headerModule.headerListsInfo;
  }

  get headlineInfo() {
    return headlineModule.headlineInfo;
  }

  get holidayInfo() {
    return holidayModule.holidayInfo;
  }

  get headerUpsertStatus() {
    return headerModule.upsertStatus;
  }

  get headerTargetId() {
    return headerModule.headerTargetId;
  }

  @Watch('headerUpsertStatus')
  private onHeaderUpsertStatus() {
    this.init();
  }

  private omittedText(header: GCIHeaderRes): string {
    return header.text.length > this.omittedNum ? header.text.slice(0, this.omittedNum) + '…' : header.text;
  }

  private async init() {
    appModule.startLoading();
    userService.requestUserInfo();
    await appModule.requestCategoryInfo({
      q: appModule.searchKeyword !== '' ? appModule.searchKeyword : '',
      s: 0,
      o: 'dp'
    }).catch(err => {
      this.errorPropagation(err);
    });
    await headerModule.requestHeaderListsInfo({
      q: '',
      s: 0,
      o: 'ap'
    }).catch(err => {
      this.errorPropagation(err);
    });
    // await headerModule.requestHeaderInfo(this.headerTargetId);
    await headlineModule.requestHeadlineInfo(1);
    await holidayModule.requestHolidayInfo(1);
    appModule.updateMeta({
      title: 'トップ',
      image: this.headerInfo.path ?? `${process.env.VUE_APP_BASE_URL}images/logo/logo.png`,
      updated_time: '',
      description: 'chiseiは福岡市南区大橋を拠点にしている美容室。'
    });
    const func = _.debounce(() => {
      appModule.stopLoading();
    }, 1000);
    func();
  }

  // エラーの伝搬
  @Emit('error')
  private errorPropagation(err: Error): Error {
    console.log(err);
    return err;
  }

  /** LifeCycle **/
  private async mounted() {
    this.init();
  }

}
